import {
  AgxAgreementDetails,
  type AgreementDetailsProps as AgxAgreementDetailsProps,
} from '@urbanx/agx.ui-components2';
import { AgreementDetails } from './types';

interface AgreementDetailsProps extends Omit<
  AgxAgreementDetailsProps,
  'defaultValue' | 'onValueChanged'
> {
  onValueChanged: (value: { id: string; value: AgreementDetails }) => void;
  defaultValue: AgreementDetails;
}

const AgreementDetailsComponent = (props: AgreementDetailsProps) => (
  <AgxAgreementDetails {...(props as unknown as AgxAgreementDetailsProps)} />
);

export default AgreementDetailsComponent;
